// Single source of truth for the flags this repo checks.
// name    — snake_case, sandbox_-prefixed, matches the gate name in the Statsig console
//           (dst_changes is a deliberate exception — see its entry below)
// default — served when the provider is unreachable/not ready; also what the local provider serves.
//           Release flags default false; only an operational switch that must survive an outage ON
//           may declare default true.
export const FLAGS = {
  SANDBOX_FLAGS_CANARY: {
    name: "sandbox_flags_canary",
    default: false,
    description:
      "Feature-flag system canary — surfaced by the /flags-debug screen; safe to flip in any tier",
  },
  SANDBOX_NEW_HOMEPAGE: {
    name: "sandbox_new_homepage",
    default: false,
    description:
      "Paid students on standalone Sandbox get the new homepage (SPDashboard) at /home by default, with the upgrade banner, the old/new switch and the banner sweep; off = the old homepage only",
  },
  // Intentionally unprefixed: ONE Statsig gate shared with StudentPortal, so a
  // single flip switches DST-aware labels on in both apps at once. The two apps
  // render the same classes — showing one abbreviation in Sandbox and a
  // different one in the Portal would be worse than shipping neither.
  DST_CHANGES: {
    name: "dst_changes",
    default: false,
    description:
      "DST-aware timezone abbreviations — derive the abbreviation from the IANA zone at each class instant instead of the hardcoded label in timeZoneList",
  },
  // Intentionally unprefixed: ONE Statsig gate shared with StudentPortal. The
  // two apps share one rotating token lineage through the shared cookies, and
  // an embedded Sandbox delegates its refresh to the portal's coordinator — a
  // per-app gate would leave the same session recovering in one app and
  // logging out in the other.
  //
  // ON: before refreshing, and again when cy-sso rejects the refresh with a
  // 401, the API client looks for a same-user, strictly-newer token pair in
  // the sibling stores and adopts it instead of logging out. OFF: a tab whose
  // tokens were rotated away by the other app more than a minute ago (past
  // cy-sso's recentDeletion grace) logs out on its next request, and its
  // sessionExpired() cascade logs the other app out too.
  AUTH_STALE_TAB_RECOVERY: {
    name: "auth_stale_tab_recovery",
    default: false,
    description:
      "A tab holding tokens the other app already rotated adopts the newer pair from the shared stores instead of logging out; off = it logs out once the rotation is over a minute old",
  },
};

const byName = Object.values(FLAGS).reduce(
  (acc, flag) => ({ ...acc, [flag.name]: flag }),
  {},
);

export const defaultFor = (flagName) => byName[flagName]?.default ?? false;
